/**
 * Smart Service + Parts Pricing:
 * When multiple repair/labor services are in the cart, keep only the highest labor fee.
 */
(function () {
  const SOURCE = 'cart-labor-pricing';
  const NOTICE_KEY = 'ff_labor_notice';
  let busy = false;

  function isEnabled() {
    return window.franchittiCheckoutConfig?.highestLaborEnabled !== false;
  }

  function saveNotice(notice) {
    if (!notice) {
      sessionStorage.removeItem(NOTICE_KEY);
      return;
    }
    sessionStorage.setItem(NOTICE_KEY, JSON.stringify(notice));
  }

  function refreshNotices() {
    document.querySelectorAll('cart-labor-notice').forEach((el) => {
      if (typeof el.refresh === 'function') el.refresh();
    });
  }

  async function enforce(event) {
    if (!isEnabled() || busy) return;
    if (event?.source === SOURCE) return;
    if (!window.FranchittiCheckout?.enforceHighestLaborOnly) return;

    busy = true;
    try {
      const cart = await FranchittiCheckout.fetchCart();
      const serviceCount = FranchittiCheckout.analyzeCart(cart).serviceCount;
      if (serviceCount === 0) {
        saveNotice(null);
        if (cart.attributes?.['Labor fee note']) {
          await FranchittiCheckout.updateCart({ attributes: { 'Labor fee note': '' } });
        }
        refreshNotices();
        return;
      }

      const result = await FranchittiCheckout.enforceHighestLaborOnly(cart);
      if (!result.changed) {
        refreshNotices();
        return;
      }

      saveNotice(result.notice);
      refreshNotices();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: SOURCE,
          cartData: result.cart,
        });
      }
    } catch (err) {
      console.warn('[Franchitti] highest-labor pricing failed', err);
    } finally {
      busy = false;
    }
  }

  class CartLaborNotice extends HTMLElement {
    connectedCallback() {
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }

    disconnectedCallback() {
      if (this.unsubscriber) this.unsubscriber();
    }

    refresh() {
      if (!isEnabled()) {
        this.hidden = true;
        return;
      }

      let notice = null;
      try {
        notice = JSON.parse(sessionStorage.getItem(NOTICE_KEY) || 'null');
      } catch {
        notice = null;
      }

      if (!notice?.winnerTitle) {
        this.hidden = true;
        return;
      }

      const titleEl = this.querySelector('[data-labor-notice-title]');
      const textEl = this.querySelector('[data-labor-notice-text]');
      const cfg = window.franchittiCheckoutConfig || {};
      const money = FranchittiCheckout.formatMoney(notice.winnerPrice);
      const waivedNames = (notice.waived || []).map((w) => w.title).filter(Boolean).join(', ');

      if (titleEl) {
        titleEl.textContent = cfg.highestLaborTitle || 'Highest labor fee only';
      }
      if (textEl) {
        const template =
          cfg.highestLaborText ||
          'You selected multiple repair services. Only the highest labor fee is charged ([price] — [title]). Other service fees are covered under that charge.';
        textEl.textContent = template
          .replace(/\[price\]|\{price\}/g, money)
          .replace(/\[title\]|\{title\}/g, notice.winnerTitle)
          .replace(/\[covered\]|\{covered\}/g, waivedNames || 'additional repairs');
      }

      this.hidden = false;
      this.classList.remove('cart-labor-notice--hidden');

      // Always start collapsed so cart items stay visible
      const details = this.querySelector('details[data-ff-cart-notice]');
      if (details) details.open = false;
    }
  }

  customElements.define('cart-labor-notice', CartLaborNotice);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      enforce(event);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enforce());
  } else {
    enforce();
  }
})();
